import { ACCESS_TOKEN_COOKIE_NAME } from "@/utils/request";
import cookies from "@/storage/cookies";
import store from "@/store";
import db from "@/storage/db";

export default {
  async isAuthenticated() {
    if (cookies.get(ACCESS_TOKEN_COOKIE_NAME)) {
      return true;
    }

    return await db.getStateValue("security.user");
  },
  async login(username, password) {
    return await store.dispatch("security/loginByUsername", {
      username,
      password,
    });
  },
  async checkSession() {
    return await store.dispatch("security/checkSession");
  },
  async clear() {
    return await store.dispatch("security/clearSession");
  },
  async logout() {
    return await store.dispatch("security/logout");
  },
};
